import { extendTheme } from "@chakra-ui/react";
import { buttonTheme } from "@/theme/components/button.styles";
import { radioTheme } from "@/theme/components/radio.styles";
import colors from "./colors";
import { checkboxTheme } from "./components/checkbox.styles";
import { inputTheme } from "./components/input.styles";
import { textareaTheme } from "./components/textarea.styles";
import { selectTheme } from "./components/select.styles";

const overrides = {
   styles: {
      global: {
         "html, body": {
            color: "brandBlue.500",
            scrollBehavior: "smooth",
            margin: 0,
         },
         a: {
            color: "brandBlue.500",
         },
      },
   },
   fonts: {
      heading: "Archivo, sans-serif",
      body: "Archivo, sans-serif",
   },
   colors,
   components: {
      Radio: radioTheme,
      Button: buttonTheme,
      Checkbox: checkboxTheme,
      Input: inputTheme,
      Textarea: textareaTheme,
      Select: selectTheme,
   },
};

export default extendTheme(overrides);
